<script setup lang="ts">
import { getTranslation } from '@/composables/data-display-utils';
import type { ConsultationProjectDto, Locales } from '@/services/types/api.types';
import type { QTableColumn } from 'quasar';
import { computed, defineProps, type ComputedRef } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const props = defineProps<{
  projects: ConsultationProjectDto[];
  languageEnabled: Locales[];
}>();

const columns: ComputedRef<QTableColumn[]> = computed(() => [
  {
    name: 'title',
    label: t('global.label.title'),
    align: 'left',
    field: (row: ConsultationProjectDto) => getTranslation(row, 'title', props.languageEnabled),
  },
  { name: 'link', label: '', field: '' },
]);

const navigateToProject = (_: Event, project: ConsultationProjectDto) => {
  window.open(`/projects/${project.id}`, '_blank');
};
</script>

<template>
  <div class="consultation-view-project-list" v-if="projects.length !== 0">
    <q-separator spaced />
    <div class="consultation-view-project-list__title">{{ t('project.projects') }}</div>
    <div class="consultation-view-project-list__subtitle">{{ t('project.consultation_projects_subtitle') }}</div>
    <q-table :rows="projects" :columns="columns" @row-click="navigateToProject" flat hide-bottom>
      <template v-slot:body-cell-link="props">
        <q-td :props="props">
          <q-icon size="20px" name="exit_to_app" />
        </q-td>
      </template>
    </q-table>
  </div>
</template>

<style lang="scss">
.consultation-view-project-list {
  &__title {
    font-size: $header;
  }

  &__subtitle {
    font-size: $sub-header;
  }
}

.project-link {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border: solid 1px $color-neutral-grey-400;
  border-radius: 20px;
  padding: 10px;
  margin: 10px 0;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);

  &:hover {
    background-color: $color-neutral-hover;
    cursor: pointer;
  }

  &__left {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
  }

  .q-icon {
    font-size: 20px;
  }
}
</style>
